/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {NgModule} from '@angular/core';

import {ClrDropdownModule} from './dropdown/dropdown.module';
import {ClrSignpostModule} from './signpost/signpost.module';
import {ClrTooltipModule} from './tooltip/tooltip.module';
export class ClrPopoverModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{exports: [ClrDropdownModule, ClrSignpostModule, ClrTooltipModule]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrPopoverModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrPopoverModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrPopoverModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
